class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this)); 
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      // console.log(cartLink);
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }


  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      // sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      const oldProgressWidth = sectionElement.querySelector('.wbship .determinate')?.style.width || '0%';
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      const progressBar = sectionElement.querySelector('.wbship .determinate');
      if (progressBar) {
        progressBar.animate([{ width: oldProgressWidth }, { width: progressBar.style.width }], { duration: 1200, easing: 'ease' });
      }
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class IhDuoSuggestions extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.addEventListener('change', (event) => {
      if (!event.target.matches('[data-duo-option]')) return;
      event.stopPropagation();
      this.updateSelection(event.target.closest('[data-duo-product]'));
    });
    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-duo-add]');
      if (!button) return;
      event.preventDefault();
      this.addArticle(button);
    });
  }

  getVariant(article) {
    const variants = JSON.parse(article.querySelector('[data-duo-variants]').textContent);
    const options = Array.from(article.querySelectorAll('[data-duo-option]'), (select) => select.value);
    if (options.some((value) => value === '')) return null;
    return variants.find((variant) => options.length === 0 || variant.options.every((value, index) => value === options[index]));
  }

  updateSelection(article) {
    const variant = this.getVariant(article);
    const button = article.querySelector('[data-duo-add]');
    const complete = Array.from(article.querySelectorAll('[data-duo-option]')).every((select) => select.value !== '');
    button.disabled = !variant?.available;
    button.textContent = complete && !variant?.available ? button.dataset.unavailable : button.dataset.idle;
    if (variant) article.querySelector('[data-duo-price]').textContent = variant.price;
    article.querySelector('[data-duo-error]').textContent = '';
  }

  async addArticle(button) {
    if (this.busy) return;
    const article = button.closest('[data-duo-product]');
    const variant = this.getVariant(article);
    if (!variant?.available) return;
    const drawer = this.closest('cart-drawer');
    const error = article.querySelector('[data-duo-error]');
    this.busy = true;
    button.disabled = true;
    button.textContent = button.dataset.busy;
    error.textContent = '';
    let added = false;
    try {
      const sectionIds = drawer.getSectionsToRender().map((section) => section.id);
      const response = await fetch(routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: variant.quantity || 1 }], sections: sectionIds, sections_url: window.location.pathname })
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || error.dataset.fallback);
      added = true;
      if (sectionIds.some((id) => !result.sections?.[id])) {
        const url = new URL(window.location.href);
        url.searchParams.set('sections', sectionIds.join(','));
        const sectionResponse = await fetch(url);
        result.sections = await sectionResponse.json();
        if (sectionIds.some((id) => !result.sections?.[id])) throw new Error(error.dataset.fallback);
      }
      drawer.classList.remove('is-empty');
      drawer.renderContents(result);
      requestAnimationFrame(() => drawer.querySelector('.drawer__close')?.focus());
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', productVariantId: variant.id });
      }
    } catch (failure) {
      if (added) {
        window.location.reload();
        return;
      }
      error.textContent = failure.message || error.dataset.fallback;
    } finally {
      this.busy = false;
      if (button.isConnected) {
        button.disabled = false;
        button.textContent = button.dataset.idle;
      }
    }
  }
}

if (!customElements.get('ih-duo-suggestions')) customElements.define('ih-duo-suggestions', IhDuoSuggestions);

